
import Lineliff from '@line/liff'

export default {
  actions: {
    initLineLiff: function(_context, liffId) {
      if (!liffId) return

      const UA = navigator.userAgent || navigator.vendor || window.opera
      const isFromLine = UA.indexOf("Line/") > -1

      if (!isFromLine) return false
      const branchClosed = JSON.parse(localStorage.getItem('branchClosed'))
      if(branchClosed.status)return false
      return Lineliff.init({ liffId }).then(() => true)
    },
    loginLineLiff: async function({ dispatch }, liffId) {
      const isInited = await dispatch('initLineLiff', liffId)

      if (!isInited) return

      const isLoggedIn = Lineliff.isLoggedIn()

      if (!isLoggedIn) return Lineliff.login()
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/line/index.js